import type React from 'react';

import { ListItem, Separator, Text } from '@change/ds-core-ui';
import { ArrowRightIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

import { useRelatedArticles } from './hooks';

const RelatedArticle: React.FC<{ articleTitle: string; slug: string }> = ({ articleTitle, slug }) => (
	<div className="col-span-2 lg:col-span-1">
		<ListItem
			forceInteractive
			className="w-full py-3 no-underline"
			as="a"
			data-qa={`${slug}-link`}
			label={
				<Text size="medium" className="w-full truncate text-left">
					{articleTitle}
				</Text>
			}
			href={`/petition-guides/${slug}?source_location=related_articles`}
			trailingIcon={<ArrowRightIcon />}
		/>
		<Separator className="border-stroke-weaker" />
	</div>
);

export const RelatedArticles: React.FC = () => {
	const {
		data: { relatedArticles },
	} = useRelatedArticles();

	if (relatedArticles.length === 0) {
		return null;
	}

	return (
		<div className="container my-16">
			<div className="mb-6">
				<Text variant="heading" size="small">
					<Translate value="corgi.petition_guides_landing_page.related_articles_section.heading" />
				</Text>
			</div>
			<div className="grid grid-cols-2 gap-x-6">
				{relatedArticles.map((article) => (
					<RelatedArticle key={article.slug} {...article} />
				))}
			</div>
		</div>
	);
};
